import { createApp } from 'vue'
import './public-path';
import App from './App.vue'
import router from './router'
import i18n from './i18n';
import store from './store'
import { setRoutes, updateRoutes, addSubAppView } from "./services/router/router.service";
import { registerMicroApps, runAfterFirstMounted } from '../es';
import { getSubDomain } from "./services/helper";
import { getComponentRoute} from "./services/backend/backend.service"
import { getComponentSubRoute} from "./services/backend/backend.service"
import { subApps as subAppsDev } from "@/main/data.sub-apps-dev"
import { subApps as subAppsProd } from "@/main/data.sub-apps"
import {getSchemaId } from "./services/data/data.service"
//@ts-ignore
import LucideComponents from "@wpmss/midone-lucide";
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import * as HeroIcons from "@heroicons/vue/24/outline";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import MidoneDashboardOverview1 from "@wpmss/midone-dashboard-overview-1"

// @ts-ignore
const isDevEnv = process.env.NODE_ENV === 'development';
const subApps = isDevEnv ? subAppsDev : subAppsProd;

let instance: { unmount: () => void; value: null; } | null = null;
const loader = (loading: boolean) => render({ loading });

if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
  store.dispatch("setDarkMode", true);
}

let allRoutes: { name: string; entry: string; container: string; activeRule: Array<string>; }[] = [];

allRoutes = subApps;
async function startApp() {
  await import("./assets/css/main.css")

  const url = window.location.href;

  if (isDevEnv) {
    subApps.forEach(element => addSubAppView(element.name, element.activeRule));
  }

  // @ts-ignore
  if (localStorage.getItem("vuex") != null && JSON.parse(localStorage.getItem("vuex")).authenticated && !url.includes("iam")) {
    try {
      //const schema = await getSchemaId();
      //localStorage.setItem("schemaId", schema);
      if (!isDevEnv) {
        const dynamicApps = await registerApps();
        allRoutes = subApps.concat(dynamicApps);

        registerMicroApps(
          allRoutes
        );
      }

      updateRoutes();
      await store.dispatch('setMenuStore');
    } catch (error) {
      console.error("failed to fetch, please log in again");
    }
  }

  const app = createApp(App).use(router).use(store).use(i18n);
  app.use(LucideComponents);
  for (const [key, icon] of Object.entries(HeroIcons)) {
    app.component(key, icon);
  }
  library.add(fas);
  library.add(fab);
  library.add(far);
  app.component('font-awesome-icon', FontAwesomeIcon);
  app.use(MidoneDashboardOverview1);

  // @ts-ignore
  app.mount('#' + process.env.VUE_APP_PUBLISHED_NAME);

  instance = app;
}

export async function registerApps() {
  render({ loading: true });

  // @ts-ignore
  const componentId = process.env.VUE_APP_CONTAINER_NAME;
  const moduleSubAppsId = '3128490047171482238'
  const subAppsFromRoute: { name: string; entry: string; container: string; loader: (loading: boolean) => Promise<void>; activeRule: Array<string>; }[] = [];
  //@ts-ignore
  const capabilityManagerRoutes = [];
   //@ts-ignore
// const capabilityManagerAliasIds = [
//    '3128490047171480242', // Technology
//   '3128490047171480578', // Workflow
//    '3128490047171489115', // Maturity
//    // add more here
//];


  if (!isDevEnv) {
    try {
      // @ts-ignore
      const applicationRoutes = await getComponentRoute(componentId);
      const subRouteResponse = await getComponentSubRoute(
        moduleSubAppsId
      );

      const capabilityManagerAliasIds = (
        subRouteResponse?.data?.items?.response?.records?.master ?? []
      ).map(
        (item: { mapper1_id: string | number }) =>
          item.mapper1_id.toString()
      );

      applicationRoutes.forEach((element: {[key: string]: string}) => {

      const activeRules: string[] = [];
      const activeRulesFromDatabase = element['active_rules'].split(",");

      activeRulesFromDatabase.forEach((rule: string) => {
        activeRules.push('/management' + rule.trim());
      });

      const appId = element['app_id'];

      if (appId == null) {
      //  console.warn(
      //    '[registerApps] Skipping record with missing app_id:',
      //    element
      //  );
        return;
      }

      if (appId.toString() === '3128304352465297294') {
                capabilityManagerRoutes.push(...activeRules);
                return;
            }

            // Modules executed by Capability Manager
            if (capabilityManagerAliasIds.includes(appId.toString())) {
                capabilityManagerRoutes.push(...activeRules);
                return;
            }

      // Normal apps still require a container.
      if (element['container'] != "n/a" && element['container'] != null) {

        if (
          appId.toString() == "3125615793803362420" ||
          appId.toString() == "3126575283239390016"
        ) {
          activeRules.push('/print');
        }

        const subApp = {
          name: appId,
          entry: 'https://' + appId + '.' + getSubDomain(),
          container: '#' + element['container'],
          loader,
          activeRule: activeRules
        };

        subAppsFromRoute.push(subApp);
      }
    });

      if (capabilityManagerRoutes.length > 0) {
            const capabilityManagerApp = {
                name: '3128304352465297294',
                entry: 'https://3128304352465297294.' + getSubDomain(),
                container: '#sub_app_1',
                loader,
                //@ts-ignore
                activeRule: [...new Set(capabilityManagerRoutes)]
            };

            subAppsFromRoute.push(capabilityManagerApp);

        }

    } catch (error) {
        console.error('[registerApps] Actual error:', error);
    }
  }

  return subAppsFromRoute;
}

registerMicroApps(
  subApps,
  //allRoutes
);

runAfterFirstMounted(() => {
  //console.log('[MainApp] first app mounted');
}
);

function hideSpinner() {
  const spinner = document.querySelector(".loadingSpinner");
  if (spinner != null) {
    //@ts-ignore
    spinner.style.display = "none";
  } else {
    setTimeout(hideSpinner, 10000);
  }
}

// eslint-disable-next-line
async function render(props = {}) {
  // TODO is this needed?
}

// eslint-disable-next-line
if (!window.__POWERED_BY_SYDONE__) {
  render();
  startApp();
}

export async function bootstrap() {
  // console.log('[contacts] contacts app bootstraped');
}

export async function mount(props: any) {
  render(props);
  startApp();
}

export async function unmount() {
  if (instance) {
    instance.unmount();

    instance.value = null;
  }
}